module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.4f8710d1.mp3";